var _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPayForDelivery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none",
    viewBox: "0 0 81 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "0a",
    width: 81,
    height: 80,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M80.2 0H.2v80h80z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#0a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "M41.6998 78c19.0539 0 34.5-8.7304 34.5-19.5S60.7537 39 41.6998 39s-34.5 8.7305-34.5 19.5S22.646 78 41.6998 78",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "1b",
    width: 64,
    height: 49,
    x: 17,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.1187 3.0007H17.7749v48.1916h62.3438z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "m56.4188 48.9378-.0023-.0013L19.8004 27.762c-.9112-.5832-1.3316-1.2272-1.3316-1.9046 0-.8475.5881-1.7692 1.9588-2.5402l.0064-.0037 12.6722-7.3074.0044-.0025c1.2275-.7196 2.8012-1.1349 4.3495-1.2003 1.5555-.0657 3.0036.2244 4.0075.8267l.0096.0057 36.6271 21.1808.0015.0009c.9606.5608 1.3193 1.1939 1.3193 1.8973 0 .8477-.5881 1.7693-1.9588 2.5403l-.0065.0037-12.6658 7.3036-.0033.0019c-1.369.7692-3.0992 1.204-4.744 1.204-1.4023 0-2.6571-.2641-3.6279-.8304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "m56.4188 45.2378-.0023-.0013L19.8004 24.062c-.9112-.5832-1.3316-1.2271-1.3316-1.9045 0-.8476.5881-1.7692 1.9588-2.5403l.0064-.0037 12.6722-7.3074.0044-.0025c1.2275-.7196 2.8012-1.1348 4.3495-1.2002 1.5555-.0658 3.0036.2244 4.0075.8266l.0096.0058 36.6271 21.1808.0015.0008c.9606.5608 1.3193 1.1939 1.3193 1.8973 0 .8477-.5881 1.7694-1.9588 2.5403l-.0065.0037-12.6658 7.3037-.0033.0018c-1.369.7693-3.0992 1.2041-4.744 1.2041-1.4023 0-2.6571-.2642-3.6279-.8305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "m56.4188 41.5379-.0023-.0013-36.6161-21.1745c-.9112-.5832-1.3316-1.2272-1.3316-1.9046 0-.8475.5881-1.7692 1.9588-2.5402l.0064-.0037 12.6722-7.3074.0044-.0025c1.2275-.7196 2.8012-1.1349 4.3495-1.2003 1.5555-.0657 3.0036.2244 4.0075.8267l.0096.0057 36.6271 21.1808.0015.0009c.9606.5608 1.3193 1.1938 1.3193 1.8973 0 .8477-.5881 1.7693-1.9588 2.5403l-.0065.0037-12.6658 7.3036-.0033.0019c-1.369.7692-3.0992 1.204-4.744 1.204-1.4023 0-2.6571-.2641-3.6279-.8304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "M78.6558 37.3921c1.3749-1.2515 1.3749-2.6817.0917-3.7544 1.4665-1.3407 1.2832-3.0392-.4584-4.0224l-1.2832-.7152-16.6824 9.8329v11.4417c1.6499 0 3.4831-.3576 4.858-1.162l12.5577-7.0618c2.2915-1.3407 2.6582-3.3074.9166-4.5588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.2539 38.0575 19.7171 16.9679c-2.22-1.2949-1.9425-3.5149.6475-4.9949l12.6722-7.3073c2.59-1.48 6.4749-1.665 8.6949-.37L78.361 25.4778c2.2199 1.295 1.9425 3.5149-.6475 4.9949l-12.7648 7.2149c-2.5899 1.4799-6.4748 1.6649-8.6948.3699"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEEBF5",
    d: "M77.9912 26.9578 41.3619 5.8682c-2.22-1.295-6.1049-1.11-8.6949.37l-12.5797 7.3073c-.925.555-1.5725 1.2025-1.85 1.85.0925.555.555 1.11 1.3875 1.5725l36.6293 21.1821c2.22 1.295 6.1049 1.11 8.6948-.37l12.6723-7.3074c.925-.555 1.5725-1.2024 1.85-1.8499-.2775-.6475-.74-1.2025-1.48-1.665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "m56.4188 37.8285-.0022-.0014-36.6162-21.1745c-.9112-.5831-1.3316-1.2271-1.3316-1.9045 0-.8476.5881-1.7692 1.9588-2.5403l.0065-.0036 12.6722-7.3074.0043-.0025c1.2276-.7197 2.8013-1.1349 4.3496-1.2004 1.5554-.0656 3.0036.2245 4.0074.8268l.0096.0057 36.6271 21.1807.0015.001c.9607.5608 1.3193 1.1938 1.3193 1.8973 0 .8476-.5881 1.7692-1.9588 2.5403l-.0065.0037L64.794 37.453l-.0032.0019c-1.369.7692-3.0992 1.204-4.7441 1.204-1.4022 0-2.6571-.2641-3.6279-.8304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.591 28.9927c-1.85-1.11-1.85-2.8675 0-3.9774.185-.0925.37-.185.6475-.2775L42.4715 8.1806c-.185.0925-.2775.2775-.4625.37-1.85 1.11-4.9949 1.11-6.8449 0-.37-.185-.555-.37-.8324-.6475l-8.4174 4.8099c.37.0925.74.2775 1.11.4625 1.85 1.11 1.85 2.8674 0 3.9774l-.555.2775 28.767 16.5572c.0925-.0925.2775-.185.4624-.2775 1.85-1.11 4.995-1.11 6.8449 0 .37.185.555.37.8325.6475l8.4173-4.8099c-.5549-.185-.9249-.37-1.2024-.555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEEBF5",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "M27.1564 17.4178a1.4 1.4 0 0 0 .0879-.0666c.9277-.5349 1.4915-1.2727 1.4915-2.2331 0-.9023-.6977-1.7313-1.5202-2.248-.1884-.1245-.3828-.2187-.5855-.3044l7.546-4.3648c.2512.2943.5685.4958.8835.6131 1.0039.5633 2.2865.8236 3.5273.8236 1.2574 0 2.558-.2674 3.5677-.8464.1215-.0624.2144-.1244.2799-.168l.0059-.004a3 3 0 0 1 .0968-.0625l28.0761 16.1809-.0547.0274c-.5238.2619-.9465.5771-1.2391.9673-.3016.4021-.4394.85-.4394 1.3181 0 .9023.6977 1.7313 1.5201 2.248.1846.122.3748.2148.5729.299l-7.6418 4.3452c-.2309-.2312-.5038-.3946-.7749-.4956-1.0039-.5632-2.2866-.8236-3.5274-.8236-1.2646 0-2.5728.2705-3.585.8565l-.0786.0456-.0561.0559-.0096.0072a2 2 0 0 1-.0779.0532l-.0042.0027c-.0141.0095-.0309.0206-.0488.0329z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.6605 23.0586c-2.7173 1.6223-7.0815 1.6223-9.7988 0s-2.7173-4.2692 0-5.8914 7.0815-1.6223 9.7988 0 2.7173 4.2692 0 5.8914"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "M48.7619 23.5817c-1.6258 0-3.2879-.3751-4.4791-1.0812-1.2105-.7174-1.7645-1.6274-1.7645-2.3875 0-.8308.5441-1.6643 1.7645-2.3876 1.1934-.7073 2.7981-1.0811 4.4499-1.0811 1.6492 0 3.2758.3728 4.5121 1.0833 1.2079.7172 1.7608 1.626 1.7608 2.3854 0 .8307-.5442 1.6642-1.7646 2.3875-1.1912.7061-2.8533 1.0812-4.4791 1.0812Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.2 50.9889.0556-16.5387 12.4965.2035c5.1244.1942 10.3783 3.5057 12.6075 8.1306l9.5273 6.7061c2.8582 1.5725 4.1625 5.0874.2868 6.5396h.0925l18.2684-.1017c1.9887-.0093 3.6074 1.6002 3.6074 3.5982 0 1.9887-1.6095 3.5982-3.5889 3.5982l-22.4771.037a11.525 11.525 0 0 1-5.5499-1.4245L5.9165 50.9704z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M.2463 50.9888h5.735l19.9796 10.9518c1.3134.7215 2.7749 1.1007 4.2734 1.1007l23.5408.111c1.9795.0092 3.5982-1.5817 3.6167-3.5704.0185-2.0073-1.6095-3.6445-3.626-3.6352l-18.9159.074"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m.2554 34.4502 11.5993.1665c5.6608.0832 10.8408 3.1912 13.5787 8.1491l11.3027 7.6496c1.3228 1.221 1.4153 3.2837.2035 4.6249-1.2209 1.3505-3.3022 1.4522-4.6526.2313l-12.6162-8.6671"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayForDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pay-for-delivery.9e7c6699a37ad6b1a9a3ccad96381395.svg";